let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aTdlO")).then(() => parcelRequire('3Id2s'));